import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  en: {
    // Navigation
    "nav.villas": "Villas",
    "nav.adventures": "Adventures",
    "nav.amenities": "Amenities",
    "nav.reviews": "Reviews",
    "nav.location": "Location",
    "nav.book": "Book Now",
    
    // Hero
    "hero.title": "Palmaréca Selah Village",
    "hero.subtitle": "Juan Dolio",
    "hero.description": "Experience tropical paradise in our exclusive villas. Beach access, adventure tours, and unforgettable memories await.",
    "hero.cta": "Explore Villas",
    "hero.cta2": "Book Your Adventure",
    "hero.heading1": "Your Private Tropical",
    "hero.heading2": "Villas",
    "hero.heading3": "in Juan Dolio",
    
    // Villas Section
    "villas.title": "Our Exclusive Villas",
    "villas.subtitle": "Each property offers unique charm and modern comforts",
    "villas.perNight": "/night",
    "villas.bookNow": "Book Now",
    
    // Adventures Section
    "adventures.badge": "Adventure Awaits",
    "adventures.title1": "Macaw Adventure",
    "adventures.title2": "Buggy Experience",
    "adventures.description": "Explore the hidden gems of Juan Dolio with our exclusive buggy tours.",
    "adventures.feature1": "Villa to beach transportation included",
    "adventures.feature2": "Discover hidden beaches & local spots",
    "adventures.feature3": "Perfect for families & groups",
    "adventures.formTitle": "Book Your Buggy Adventure",
    "adventures.fullName": "Full Name",
    "adventures.phone": "Phone",
    "adventures.email": "Email",
    "adventures.date": "Preferred Date",
    "adventures.guests": "Guests",
    "adventures.message": "Special Requests (Optional)",
    "adventures.submit": "Request Booking",
    "adventures.submitting": "Sending...",
    "adventures.marketingOptIn": "Allow Palmaréca Selah Village to send me exclusive promotions, deals, and travel tips via email",
    
    // Amenities
    "amenities.badge": "Amenities",
    "amenities.title": "Everything You Need",
    "amenities.subtitle": "Our villas come fully equipped with premium amenities",
    "amenities.pools": "Private Pools & Jacuzzis",
    "amenities.poolsDesc": "Refresh in your own private oasis",
    "amenities.bbq": "Gas BBQ Areas",
    "amenities.bbqDesc": "Grill like a local with premium equipment",
    "amenities.checkin": "Self Check-in",
    "amenities.checkinDesc": "Seamless arrival at your convenience",
    "amenities.wifi": "High-Speed WiFi",
    "amenities.wifiDesc": "Stay connected throughout your stay",
    "amenities.generator": "24/7 Generator",
    "amenities.generatorDesc": "Uninterrupted power for your comfort",
    "amenities.parking": "Free Parking",
    "amenities.parkingDesc": "Secure parking for all guests",
    
    // Reviews
    "reviews.badge": "Guest Reviews",
    "reviews.title": "What Our Guests Say",
    "reviews.writeReview": "Write a Review",
    "reviews.formTitle": "Share Your Experience",
    "reviews.formSubtitle": "Your review helps other guests!",
    "reviews.yourName": "Your Name *",
    "reviews.locationLabel": "Location *",
    "reviews.emailLabel": "Email *",
    "reviews.emailNote": "Your email won't be published",
    "reviews.ratingLabel": "Your Rating *",
    "reviews.reviewLabel": "Your Review *",
    "reviews.reviewPlaceholder": "Tell us about your stay...",
    "reviews.submitReview": "Submit Review",
    "reviews.submitting": "Submitting...",
    "reviews.submitNote": "By submitting, you agree that your review may be published on our website.",
    
    // House Rules
    "rules.badge": "Important Info",
    "rules.title": "House Rules & Fees",
    "rules.subtitle": "Please review these guidelines",
    "rules.houseRules": "House Rules",
    "rules.checkinTime": "Check-in: 3:00 PM",
    "rules.checkoutTime": "Check-out: 11:00 AM",
    "rules.capacity": "Respect Capacity",
    "rules.capacityDesc": "Strict maximum guest limits",
    "rules.parties": "No Unauthorized Parties",
    "rules.partiesDesc": "Private events only",
    "rules.feesTitle": "Additional Fees",
    "rules.generatorFee": "Generator Fee",
    "rules.generatorAmount": "$20-30 USD/night",
    "rules.generatorDesc": "For 24/7 power",
    "rules.bbqFee": "BBQ Gas",
    "rules.bbqAmount": "$15 USD",
    "rules.bbqDesc": "One-time fee per stay",
    "rules.feesNote": "* These fees ensure uninterrupted power and full amenities",
    
    // Location
    "location.badge": "Location",
    "location.title1": "Juan Dolio,",
    "location.title2": "Dominican Republic",
    "location.description": "Nestled in a quiet area surrounded by nature.",
    
    // Booking Modal
    "booking.selectDates": "Click dates to book",
    "booking.checkin": "Check-in",
    "booking.checkout": "Check-out",
    "booking.clear": "Clear",
    "booking.fullName": "Full Name",
    "booking.phone": "Phone",
    "booking.email": "Email",
    "booking.guests": "Guests",
    "booking.requests": "Requests",
    "booking.additionalServices": "Additional Services",
    "booking.generator": "24/7 Generator",
    "booking.generatorDesc": "Uninterrupted power for AC, lights & appliances",
    "booking.bbqGas": "BBQ Gas",
    "booking.bbqDesc": "One-time fee for the entire stay",
    "booking.discountCode": "Discount code",
    "booking.apply": "Apply",
    "booking.total": "Total",
    "booking.selectDatesToBook": "Select dates to book",
    "booking.requestReservation": "Request Reservation",
    "booking.submitting": "Submitting...",
    "booking.confirmNote": "We'll contact you via WhatsApp or email to confirm",
    "booking.marketingOptIn": "Send me exclusive deals and travel tips",
    
    // Footer
    "footer.tagline": "Your gateway to luxury tropical living in Juan Dolio.",
    "footer.bookStay": "Book Your Stay",
    "footer.contact": "Get In Touch",
    "footer.copyright": "All rights reserved",
    
    // Common
    "common.nights": "nights",
    "common.night": "night",
    "common.flat": "flat",
    "common.perNight": "/night",
    "common.booked": "booked",
    "common.selected": "Selected",
    "common.range": "Range",
  },
  es: {
    // Navigation
    "nav.villas": "Villas",
    "nav.adventures": "Aventuras",
    "nav.amenities": "Comodidades",
    "nav.reviews": "Reseñas",
    "nav.location": "Ubicación",
    "nav.book": "Reservar",
    
    // Hero
    "hero.title": "Palmaréca Selah Village",
    "hero.subtitle": "Juan Dolio",
    "hero.description": "Experimenta el paraíso tropical en nuestras villas exclusivas. Acceso a la playa, tours de aventura y recuerdos inolvidables te esperan.",
    "hero.cta": "Explorar Villas",
    "hero.cta2": "Reserva Tu Aventura",
    "hero.heading1": "Tus Villas Tropicales",
    "hero.heading2": "Privadas",
    "hero.heading3": "en Juan Dolio",
    
    // Villas Section
    "villas.title": "Nuestras Villas Exclusivas",
    "villas.subtitle": "Cada propiedad ofrece encanto único y comodidades modernas",
    "villas.perNight": "/noche",
    "villas.bookNow": "Reservar",
    
    // Adventures Section
    "adventures.badge": "La Aventura Te Espera",
    "adventures.title1": "Macaw Adventure",
    "adventures.title2": "Experiencia en Buggy",
    "adventures.description": "Explora las joyas escondidas de Juan Dolio con nuestros tours exclusivos en buggy.",
    "adventures.feature1": "Transporte de villa a playa incluido",
    "adventures.feature2": "Descubre playas escondidas y lugares locales",
    "adventures.feature3": "Perfecto para familias y grupos",
    "adventures.formTitle": "Reserva Tu Aventura en Buggy",
    "adventures.fullName": "Nombre Completo",
    "adventures.phone": "Teléfono",
    "adventures.email": "Correo",
    "adventures.date": "Fecha Preferida",
    "adventures.guests": "Personas",
    "adventures.message": "Solicitudes Especiales (Opcional)",
    "adventures.submit": "Solicitar Reserva",
    "adventures.submitting": "Enviando...",
    "adventures.marketingOptIn": "Permitir que Palmaréca Selah Village me envíe promociones exclusivas y consejos de viaje",
    
    // Amenities
    "amenities.badge": "Comodidades",
    "amenities.title": "Todo Lo Que Necesitas",
    "amenities.subtitle": "Nuestras villas están completamente equipadas con comodidades premium",
    "amenities.pools": "Piscinas Privadas y Jacuzzis",
    "amenities.poolsDesc": "Refréscate en tu propio oasis privado",
    "amenities.bbq": "Áreas de BBQ a Gas",
    "amenities.bbqDesc": "Cocina como un local con equipo premium",
    "amenities.checkin": "Auto Check-in",
    "amenities.checkinDesc": "Llegada sin complicaciones a tu conveniencia",
    "amenities.wifi": "WiFi de Alta Velocidad",
    "amenities.wifiDesc": "Mantente conectado durante tu estadía",
    "amenities.generator": "Generador 24/7",
    "amenities.generatorDesc": "Energía ininterrumpida para tu comodidad",
    "amenities.parking": "Estacionamiento Gratis",
    "amenities.parkingDesc": "Estacionamiento seguro para todos los huéspedes",
    
    // Reviews
    "reviews.badge": "Reseñas de Huéspedes",
    "reviews.title": "Lo Que Dicen Nuestros Huéspedes",
    "reviews.writeReview": "Escribir Reseña",
    "reviews.formTitle": "Comparte Tu Experiencia",
    "reviews.formSubtitle": "¡Tu reseña ayuda a otros huéspedes!",
    "reviews.yourName": "Tu Nombre *",
    "reviews.locationLabel": "Ubicación *",
    "reviews.emailLabel": "Correo *",
    "reviews.emailNote": "Tu correo no será publicado",
    "reviews.ratingLabel": "Tu Calificación *",
    "reviews.reviewLabel": "Tu Reseña *",
    "reviews.reviewPlaceholder": "Cuéntanos sobre tu estadía...",
    "reviews.submitReview": "Enviar Reseña",
    "reviews.submitting": "Enviando...",
    "reviews.submitNote": "Al enviar, aceptas que tu reseña puede ser publicada en nuestro sitio web.",
    
    // House Rules
    "rules.badge": "Información Importante",
    "rules.title": "Reglas de la Casa y Tarifas",
    "rules.subtitle": "Por favor revisa estas pautas",
    "rules.houseRules": "Reglas de la Casa",
    "rules.checkinTime": "Check-in: 3:00 PM",
    "rules.checkoutTime": "Check-out: 11:00 AM",
    "rules.capacity": "Respetar Capacidad",
    "rules.capacityDesc": "Límites estrictos de huéspedes",
    "rules.parties": "Sin Fiestas No Autorizadas",
    "rules.partiesDesc": "Solo eventos privados",
    "rules.feesTitle": "Tarifas Adicionales",
    "rules.generatorFee": "Tarifa del Generador",
    "rules.generatorAmount": "$20-30 USD/noche",
    "rules.generatorDesc": "Para energía 24/7",
    "rules.bbqFee": "Gas BBQ",
    "rules.bbqAmount": "$15 USD",
    "rules.bbqDesc": "Tarifa única por estadía",
    "rules.feesNote": "* Estas tarifas garantizan energía ininterrumpida y todas las comodidades",
    
    // Location
    "location.badge": "Ubicación",
    "location.title1": "Juan Dolio,",
    "location.title2": "República Dominicana",
    "location.description": "Ubicado en una zona tranquila rodeada de naturaleza.",
    
    // Booking Modal
    "booking.selectDates": "Selecciona fechas para reservar",
    "booking.checkin": "Llegada",
    "booking.checkout": "Salida",
    "booking.clear": "Borrar",
    "booking.fullName": "Nombre Completo",
    "booking.phone": "Teléfono",
    "booking.email": "Correo",
    "booking.guests": "Personas",
    "booking.requests": "Solicitudes",
    "booking.additionalServices": "Servicios Adicionales",
    "booking.generator": "Generador 24/7",
    "booking.generatorDesc": "Energía ininterrumpida para AC, luces y electrodomésticos",
    "booking.bbqGas": "Gas BBQ",
    "booking.bbqDesc": "Tarifa única para toda la estadía",
    "booking.discountCode": "Código de descuento",
    "booking.apply": "Aplicar",
    "booking.total": "Total",
    "booking.selectDatesToBook": "Selecciona fechas para reservar",
    "booking.requestReservation": "Solicitar Reserva",
    "booking.submitting": "Enviando...",
    "booking.confirmNote": "Te contactaremos por WhatsApp o correo para confirmar",
    "booking.marketingOptIn": "Envíenme ofertas exclusivas y consejos de viaje",
    
    // Footer
    "footer.tagline": "Tu puerta de entrada a la vida tropical de lujo en Juan Dolio.",
    "footer.bookStay": "Reserva Tu Estadía",
    "footer.contact": "Contáctanos",
    "footer.copyright": "Todos los derechos reservados",
    
    // Common
    "common.nights": "noches",
    "common.night": "noche",
    "common.flat": "fijo",
    "common.perNight": "/noche",
    "common.booked": "reservado",
    "common.selected": "Seleccionado",
    "common.range": "Rango",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("preferred_language");
    return saved || "en";
  });

  useEffect(() => {
    localStorage.setItem("preferred_language", language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations["en"]?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === "en" ? "es" : "en");
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageContext;
